import './style/index.scss';


(async () => {
  const {
    Swiper,
    Navigation,
    Pagination,
    Virtual,
    Autoplay
  } = await import( /* webpackChunkName: "swiper" */ 'swiper')
  Swiper.use([ Navigation, Pagination, Virtual, Autoplay])
  new Swiper('.swiper-container', {
    observer: true,
    autoplay: true,
    slidesPerView: 3,
    // spaceBetween: 100,
    centeredSlides: true,
    loop: true,
    on: {
      slideChange: function (swiper) {
        $('.swiper-introduce-titles-item').removeClass('active-title')
        $('.swiper-introduce-contents-item').removeClass('active-content')
        $('.swiper-introduce-titles-item').eq(swiper.realIndex).addClass('active-title')
        $('.swiper-introduce-contents-item').eq(swiper.realIndex).addClass('active-content')
      },
    },
  })


  const mySwiper = new Swiper('.swiper3', {
    // 与 virtual 冲突
    // initialSlide: 1,
    observer: true,
    slidesPerView: 3,
    centeredSlides: true,
    // spaceBetween: 0,
    autoplay: true,
    // loop: true,
    virtual: {
      // addSlidesBefore: 3,
      // addSlidesAfter: 3,
      slides: (function () {
        var slides = [];
        for (var i = 0; i < 9; i += 1) {
          slides.push(`https://static.qifeizn.com/resources/os/images/drone_100P_scenes_${i}202407.png`);
        }
        return slides;
      }()),
      renderSlide: function (slide) {
        return `<div class="swiper-slide" ><img src="${slide}"></img></div>`
      }
    },
    on: {
      observerUpdate: function () {
        // console.log(mySwiper.virtual.slides);
      },
    },
  });

})()


const swiperOne = (parentClass) => {
  let data = {
    index: 0,
    time: null
  }
  let ulBox = $(parentClass +' .centrifugal-nozzle-swiper-selection ul')
  let selectionItems = $(parentClass + ' .centrifugal-nozzle-swiper-selection li')
  let selectionTitle = $(parentClass + ' .centrifugal-nozzle-swiper-selection li .selection-title')
  let selectionContent = $(parentClass + ' .centrifugal-nozzle-swiper-selection li .selection-content')
  let selectionBefore = $(parentClass + ' .centrifugal-nozzle-two-kinds-swiper .selection-before')
  let viewImg = $(parentClass + ' .centrifugal-nozzle-swiper-view .view-img')

  const active = () => {
    selectionContent.css({ 'height': 0 })
    viewImg.css({ 'opacity': '0' })
    selectionTitle.css({
      'color': '#bcbcbc'
    })

    let rectContent = selectionItems.get(data.index).querySelector('p').getBoundingClientRect()
    let rectItem = selectionItems.get(data.index).getBoundingClientRect()
    let rectUl = ulBox.get(0).getBoundingClientRect()
    selectionContent.eq(data.index).css({
      'height': rectContent.height + 'px',
      'opacity': '1'
    })
    selectionTitle.eq(data.index).css({
      'color': '#000'
    })

    let top = 0;

    for (let i = 0; i < data.index; i++) {
      top += selectionItems.get(i).getBoundingClientRect().height
    }

    if (!data.index) top = 0

    selectionBefore.css({
      'height': rectItem.height + 'px',
      'top': top + 'px'
    })

    viewImg.eq(data.index).css({
      'opacity': '1'
    })


  }

  active()

  selectionItems.click(function () {
    clearInterval(data.time)
    data.index = parseInt($(this).attr('data-index'))
    active()
  })
}


const swiperTwo = () => {
  let data = {
    index: 0,
    time: null
  }
  let ulBox = $('.drone-B100P-camera .centrifugal-nozzle-swiper-selection ul')
  let selectionItems = $('.drone-B100P-camera .centrifugal-nozzle-swiper-selection li')
  let selectionTitle = $('.drone-B100P-camera .centrifugal-nozzle-swiper-selection li .selection-title')
  let selectionContent = $('.drone-B100P-camera .centrifugal-nozzle-swiper-selection li .selection-content')
  let selectionBefore = $('.drone-B100P-camera .centrifugal-nozzle-two-kinds-swiper .selection-before')
  let viewImg = $('.drone-B100P-camera .centrifugal-nozzle-swiper-view .view-img')

  const active = () => {
    selectionContent.css({ 'height': 0 })
    viewImg.css({ 'opacity': '0' })
    selectionTitle.css({
      'color': '#bcbcbc'
    })

    let rectContent = selectionItems.get(data.index).querySelector('p').getBoundingClientRect()
    let rectItem = selectionItems.get(data.index).getBoundingClientRect()
    let rectUl = ulBox.get(0).getBoundingClientRect()
    selectionContent.eq(data.index).css({
      'height': rectContent.height + 'px',
      'opacity': '1'
    })
    selectionTitle.eq(data.index).css({
      'color': '#000'
    })

    let top = 0;

    for (let i = 0; i < data.index; i++) {
      top += selectionItems.get(i).getBoundingClientRect().height
    }

    if (!data.index) top = 0

    selectionBefore.css({
      'height': rectItem.height + 'px',
      'top': top + 'px'
    })

    viewImg.eq(data.index).css({
      'opacity': '1'
    })


  }

  active()

  selectionItems.click(function () {
    clearInterval(data.time)
    data.index = parseInt($(this).attr('data-index'))
    active()
  })
}

swiperOne('.drone-B100P-model');
swiperOne('.drone-B100P-camera');
swiperOne('.drone-B100P-ground');
swiperOne('.drone-B100P-battery-life');
// swiperTwo();
$('.video-button').click(function () {
  var url = $(this).attr('dataId')
  $('.video-mask').show()
  $('.video-mask video').attr('src', url);
})
$('.video-close').click(function () {
  $('.video-mask').hide()
  $('.video-mask video').attr('src', '');
})
